/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { Virtuoso } from 'react-virtuoso';

export const Field = styled.div`
  width: 800px;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(30, 50, 70, 0.1), 0px 1px 2px rgba(30, 50, 70, 0.06);
  padding: 32px 40px;
`;

export const Header = styled.h2`
  color: ${Palette.PrimaryGray._900};
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  margin: 0;
  text-align: left;
  margin-bottom: 32px;
`;

export const TableRow = styled.div`
  border: 1px solid ${Palette.PrimaryGray._200};
  border-bottom: none;
  display: flex;
`;

export const TableBody = styled.div`
  div:last-child {
    border: 1px solid ${Palette.PrimaryGray._200};
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  border-bottom: 1px solid ${Palette.PrimaryGray._200};
  border-bottom: ${({ isLastElement }) => isLastElement && 'none'};
  > span:first-child {
    font-weight: 500;
  }
  > span {
    font-size: 14px;
  }
  :hover {
    background: ${Palette.PrimaryGray._000};
  }
`;
export const ItemElement = styled.div`
  text-transform: capitalize;
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  text-align: ${({ textPosition }) => (textPosition ? textPosition : 'center')};
  padding-left: ${({ paddingLeft }) => (paddingLeft ? `${paddingLeft}px` : '0px')};
  display: flex;
  align-items: center;
  color: ${Palette.PrimaryGray._700};
  font-style: normal;
  font-weight: 400;
  line-height: 40px;
`;

export const SubTitle = styled.span`
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const InputContainer = styled.div`
  display: flex;
  margin-top: 32px;
`;

export const IconWrap = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  border-radius: 4px 0 0 4px;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-right: none;
  padding: 8px;
  max-width: 140px;
`;

export const CopyIconWrap = styled.div`
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-left: none;
  border-radius: 0 4px 4px 0;
`;

export const MyVirtuoso = styled(Virtuoso)`
  border: 1px solid ${Palette.PrimaryGray._200};
  ::-webkit-scrollbar {
    width: 6px;
    background-color: #fff;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;
